import React from 'react';
import style from './style.scss'

const CheckboxGroup = (props) => {
    const {field,type="checkbox"} = props;

    return (<div className="">

        <label className={style.formLabel}
            htmlFor={field.elementId}>
            {field.label}{field.required&&<span className={style.asterisk}> *</span>}
        </label>

        { field.options && field.options.map((option, i) => {
            return (
                <label className={style.formField}>
                    <input
                        type={type}
                        key={i}
                        value={option.value} />
                    {option.label}
                </label>
            );
        })}

    </div>)
}

export default CheckboxGroup;
